import type { CsvStatementBalanceOptions } from "@/lib/csv-to-beancount";

export interface CsvStatementFormState {
  enabled: boolean;
  startDateText: string;
  endDateText: string;
  openingText: string;
  closingText: string;
}

/**
 * Fresh statement panel state. Profiles, sample loads and mapping resets must
 * restore this — never keep prior balances across an incompatible CSV or
 * mapping, or a stale match can survive a Load / Try sample click.
 */
export const EMPTY_CSV_STATEMENT_FORM: CsvStatementFormState = {
  enabled: false,
  startDateText: "",
  endDateText: "",
  openingText: "",
  closingText: "",
};

/** Map panel state into convert options; `undefined` keeps ordinary conversion. */
export function statementOptionsFromForm(
  form: CsvStatementFormState,
  currency: string,
): CsvStatementBalanceOptions | undefined {
  if (!form.enabled) return undefined;
  return {
    enabled: true,
    startDateText: form.startDateText,
    endDateText: form.endDateText,
    openingText: form.openingText,
    closingText: form.closingText,
    currency,
  };
}
